import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import {
  AbstractCachePagingService,
  ContactDoc,
  ContactElsQuery,
  ElasticSearchService,
  JsonMap,
  PagingParams,
  VisibilityElsInterceptor,
} from '@contact/upgrade';

export enum HistoryContactFilter {
  FIRSTNAME = 'FIRSTNAME',
  LASTNAME = 'LASTNAME',
  CONTACT_ID = 'CONTACT_ID',
  COMPANY_NAME = 'COMPANY_NAME',
  PHONE = 'PHONE',
  MAIL = 'MAIL',
  REPOSITORY = 'REPOSITORY',
}

@Injectable({
  providedIn: 'root',
})
export class HistoryContactSource extends AbstractCachePagingService<ContactDoc> {
  constructor(private readonly elasticSerchService: ElasticSearchService) {
    super();
  }

  protected _load(param: PagingParams<JsonMap>) {
    // extract filter
    const form = param && param.form;
    const firstname = form && (form[HistoryContactFilter.FIRSTNAME] as string);
    const lastname = form && (form[HistoryContactFilter.LASTNAME] as string);
    const companyname = form && (form[HistoryContactFilter.COMPANY_NAME] as string);
    const contactId = form && (form[HistoryContactFilter.CONTACT_ID] as string);
    const phone = form && (form[HistoryContactFilter.PHONE] as string);
    const mail = form && (form[HistoryContactFilter.MAIL] as string);
    const repository = form && (form[HistoryContactFilter.REPOSITORY] as string);
    const index = (param && param.pageIndex) || 0;
    const size = (param && param.pageSize) || 10;
    const from = index * (size || 0);
    let sort = param && param.sortActive;
    if (sort && sort.toLowerCase().indexOf('date') === -1) {
      sort = `${sort}.keyword`;
    }
    const direction = (param && param.sortDirection) || '';
    const query = ContactElsQuery.buildSearch({
      firstname,
      lastname,
      companyname,
      contactId,
      phone,
      mail,
      size,
      from,
      sort: sort && direction ? { [sort]: direction } : undefined,
    });

    // search
    const search$ = repository
      ? // remove visibility interceptor to apply visibility manually
        this.elasticSerchService.removeInterceptor(VisibilityElsInterceptor).search(
          query.cloneBoolMust({
            term: {
              'customerRepositoryName.keyword': repository,
            },
          })
        )
      : // visibility will be apply by interceptor
        this.elasticSerchService.search(query);

    return search$.pipe(
      map(result => ({
        ...result,
        ...param,
      }))
    );
  }
}
